import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const MobileMenuRoot = styled.div`
  display: none;

  /* 768px, not CHAT_MOBILE_BREAKPOINT (767): the burger bar that opens this
     menu shows at <=768px, and at exactly 768px a tap used to lock body scroll
     while the menu stayed display:none. */
  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileMenuBackdrop = styled.button`
  border: none;
  padding: 0;
  background: rgba(13, 20, 36, 0.18);
  position: fixed;
  inset: 0;
  z-index: 1190;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: opacity 0.2s ease;
`;

export const MobileMenuPanel = styled.aside`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  padding: 0;
  background: var(--surface);
  box-shadow: none;
  position: fixed;
  left: 0;
  z-index: 1200;
  transform: ${({ $open }) => ($open ? "translateY(0)" : "translateY(-110%)")};
  transition: transform 0.24s ease;
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  display: flex;
  flex-direction: column;
  gap: 38px;
  overflow-y: auto;
`;

export const MobileMenuHeader = styled.div`
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
`;

export const MobileMenuLogoLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const MobileMenuCloseButton = styled.button`
  width: 18px;
  height: 20px;
  border: none;
  background: transparent;
  color: var(--text-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);

  svg {
    font-size: 24px;
  }

  /* An 18x20 hit box is too small to tap; grow it around the same icon centre. */
  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    right: 5px;
  }
`;

export const MobileMenuList = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Figma 2747-7295: contiguous 55px rows, no extra spacing between them. */
  gap: 0;
`;

export const MobileMenuLink = styled(NavLink)`
  width: 100%;
  display: block;
  text-decoration: none;
  color: inherit;

  &:last-of-type {
    margin-top: auto;
    /* Figma 2747-7295: the pinned Settings row carries a bottom hairline. */
    border-bottom: 1px solid var(--border);
  }
`;

export const MobileMenuItem = styled.div`
  /* Figma 2747-7295: 55px row, icon and label centered as a pair. */
  min-height: 55px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  color: rgba(24, 126, 225, 1);
  background: transparent;
  transition:
    transform 0.18s ease,
    color 0.18s ease;

  &:active {
    transform: scale(0.98);
  }
`;

export const MobileMenuLogoutButton = styled(MobileMenuItem).attrs({
  as: "button",
})`
  width: 100%;
  flex-shrink: 0;
  border: none;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  font: inherit;

  &:focus-visible {
    outline: 2px solid rgba(25, 118, 210, 1);
    outline-offset: -3px;
  }
`;

export const MobileMenuIcon = styled.div`
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  svg {
    display: block;
    width: 20px;
    height: 20px;
  }
`;

export const MobileMenuLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.45;
  color: rgba(25, 118, 210, 1);
`;
